module.exports = __webpack_public_path__ + "img/icon_social.f901582.svg";